module.exports = __webpack_public_path__ + "static/media/13.c4b115a9.mp3";